import {AxiosRequestConfig} from 'axios';
import {DEFAULT_RETRY_CONFIG} from 'common/constants';
import {
  API_GET_ALL_BRANDS,
  API_POST_DELETE_BRAND,
  API_POST_UPSERT_BRAND,
} from 'common/constants/apis';
import {CRASHLYTICS_AUTH_ERROR} from 'common/constants/errors';
import {ServerResponse} from 'common/interfaces';
import {
  IBrand,
  IBrandListResp,
  IBrandUpdateResp,
} from 'common/interfaces/ibrand';
import UILogger, {LogRecordType, LogSeverityType} from 'common/utils/logger';
import httpClient from './config';

export const getBrandList = async (): Promise<IBrandListResp> => {
  UILogger.log('BrandService: Getting brands: ');
  return httpClient
    .get(API_GET_ALL_BRANDS)
    .then(res => {
      UILogger.log('BrandService: Getting brands done, ', res.data);
      if (res.status === 200) {
        return res.data;
      }
      return {status: {success: false}} as IBrandListResp;
    })
    .catch(error => {
      if (error?.response?.status !== 401) {
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_AUTH_ERROR,
          },
          'Error in getting brands',
          error,
        );
      }
      UILogger.log('Error in getting brands. status:', error?.response?.status);
      return {status: {success: false}} as IBrandListResp;
    });
};

export const postUpdateBrand = (payload: IBrand): Promise<IBrandUpdateResp> => {
  UILogger.info('Sending update brand request', payload);
  return httpClient
    .post(
      API_POST_UPSERT_BRAND,
      payload,
      DEFAULT_RETRY_CONFIG as AxiosRequestConfig,
    )
    .then(res => {
      UILogger.log('add brand response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error upserting brand:::', error.response.data);
      return error.response.data;
    });
};

export const postDeleteBrand = (brandId: number): Promise<ServerResponse> => {
  UILogger.info('Sending deleter brand request for brand: ', brandId);
  return httpClient
    .delete(
      API_POST_DELETE_BRAND + brandId,
      DEFAULT_RETRY_CONFIG as AxiosRequestConfig,
    )
    .then(res => {
      UILogger.log('delete brand response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error deleting brand:::', error.response.data);
      return error.response.data;
    });
};
